import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import { getCityState } from "../../../../action/user_action";
import { ANY_ERROR } from "../../../../action/user_action_types";
import { endPoints } from "../../../../config";
import http from "../../../../util/http";
import LinkedStateMixin from "react-addons-linked-state-mixin"; // ES6
import {
  SALES_USERS_DATA,
  STATE_LIST,
} from "../../../../action/salesUser_action_types";
import { getServerDataWithTypes } from "../../../../action/common_action";
import { axiosInstnace as Axios } from "../../../../util/util";
class EditAdminUserComp extends Component {
  constructor(props) {
    super(props);

    var adminDetails = props.adminDetail ? props.adminDetail : undefined;

    this.state = {
      adminField: {
        email: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
        name: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
        mobile: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
        role: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
        state: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
        city: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
        station: adminDetails
          ? adminDetails.email
            ? adminDetails.email
            : ""
          : "",
      },
      showError: false,

      stateList: ["Select State"],

      stationList: [
        "Select Station",
        "Tirupati",
        "Itanagar",
        "Guwahati",
        "Muzaffarpur",
        "Patna",
        "Chandigarh",
        "Delhi",
        "Panaji",
        "Baroda",
        "Rajkot",
        "Surat",
        "Hissar",
        "Shimla",
        "Jammu",
        "Srinagar",
        "Jamshedpur",
        "Ranchi",
        "Bangalore",
        "Mangalore",
        "Mysore",
        "Trivandrum",
        "Gwalior",
        "Bhopal",
        "Indore",
        "Ahmednagar",
        "Aurangabad",
        "Kolhapur",
        "Nagpur",
        "Sholapur",
        "Mumbai",
        "Pune",
        "Shillong",
        "Aizawl",
        "Bhubaneshwar",
        "Rourkela",
        "Pondicherry",
        "Amritsar",
        "Jalandhar",
        "Patiala",
        "Ajmer",
        "Bikaner",
        "Jodhpur",
        "Kota",
        "Udaipur",
        "Chennai",
        "Hyderabad",
        "Agartala",
        "Agra",
        "Aligarh",
        "Allahabad",
        "Bareilly",
        "Gorakhpur",
        "Jhansi",
        "Kanpur",
        "Lucknow",
        "Varanasi",
        "Asansol",
        "Kolkata",
      ],
      cityList: [{ city: "Select City" }],
      roleList: [
        { role: "", name: "Select Admin" },
        { role: "salesUser", name: "Sales User" },
        { role: "auditAdmin", name: "Audit Admin" },
        { role: "stationAdmin", name: "Station Admin" },
        { role: "trafficAdmin", name: "Traffic Admin" },
        { role: "clusterAdmin", name: "Cluster Admin" },
      ],
      clusterList: [],
    };
  }
  componentDidMount = () => {
    this.getAllStates();
    this.getCityList(this.state.adminField.state);
  };

  getAllStates = async () => {
    const response = await Axios.get(`${endPoints.getClusters}`, {
      params: { type: "all" },
    });
    console.log(response.data);
    console.log(response.data.data.allData);
    this.state.clusterList = response.data.data.allData;
    console.log(this.state.clusterList);
    // this.state.adminField.cluster = this.state.clusterList[0].name;
    this.props.getStateList(`${endPoints.getStateList}`, STATE_LIST);
  };

  componentWillReceiveProps = (nextProps) => {
    console.log("on Data receive props on Add cluster page", nextProps);
    let { stateList } = nextProps;
    this.setState({
      stateList: stateList && stateList.data ? stateList.data : [],
    });
  };

  handleClusterChange = (event) => {
    let {adminField} = this.state
    adminField.cluster = event;
    this.setState({
      adminField
    })
  };

  handleStateChange = (event) => {
    let {adminField} = this.state
    adminField.state = event;
    this.setState({
      adminField
    })
    this.getCityList(event);
  };

  getCityList = async (state) => {
    const response = await Axios.get(`${endPoints.getCities}?state=${state}`);
    console.log(response.data.data.data);
    let districtList = response.data.data.data;
    this.setState({
      cityList: districtList ? districtList : [],
    });
    this.state.adminField.city = districtList[0].value;
  };
  handleStationChange = (event) => {
    let {adminField} = this.state
    adminField.station = event;
    this.setState({
      adminField
    })

  };

  handleCityChange = (event) => {
    let {adminField} = this.state
    adminField.city = event;
    this.setState({
      adminField
    })

  }


  handleRoleChange = (event) => {
    let {adminField} = this.state
    adminField.role = event;
    this.setState({
      adminField
    })

  };

  componentWillReceiveProps = (nextProps) => {
    console.log("on Data receive props on Add cluster page", nextProps);
    let { stateList } = nextProps;
    this.setState({
      stateList: stateList && stateList.data ? stateList.data : [],
    });
  };

  serverCalls = async (url, data) => {
    const response = await http.post(url, data);
    if (response && response.data.statusCode == 200) {
      // this.componentDidMount();
      var data = response.data.data[0]
        ? response.data.data[0]
        : response.data.data;
      console.log("Response", data);
      this.state.adminField.name = data.name;
      this.state.adminField.email = data.email;
    } else {
      this.props.showError(
        response ? response.data.message : "Something is wrong"
      );
    }
  };

  //Handle the admin fields
  handleChange = (event) => {
    console.log(event.target);
    let {
      name,
      mobile,
      email,
      role,
      station,
      state,
      city,
      value,
    } = event.target;
    let { adminField } = this.state;
    this.setState({
      adminField: {
        ...adminField,
        [name]: value,
        [mobile]: value,
        [email]: value,
        [role]: value,
        [state]: value,
        [city]: value,
        [station]: value,
      },
    });

    console.log("Changed value", this.state.adminField);
  };

  //Adding an admin to database
  addAdmin = () => {
    let { adminField } = this.state;
    let { email } = adminField;
    let { name } = adminField;
    let { state } = adminField;
    let { mobile } = adminField;
    let { role } = adminField;
    let { city } = adminField;
    let { station } = adminField;
    let { cluster } = adminField;

    let domain = email.slice(email.lastIndexOf("@") + 1);
    console.log("Email domain", domain);
    if (email === "") {
      this.props.showError("Email can not be blank!");
    }
    // else if(domain!= "affle.com" && domain!= "radiobigfm.com") {
    //   this.props.showError("Email must contain either affle.com or radiobigfm.com domain!");
    // }
    else if (domain !== "buyadsonbigfm.com" && domain !== "radiobigfm.com") {
      this.props.showError(
        "Email must contain either buyadsonbigfm.com or radiobigfm.com domain!"
      );
    } else {
      let data = { email, name, mobile, state, role, station, city };
      this.props.addAdmin(data);
    }
  };

  updateAdmin = () => {
    console.log(this.state);
    let { adminField } = this.state;
    console.log(adminField);
    let { email } = adminField;
    let { name } = adminField;
    let { state } = adminField;
    let { mobile } = adminField;
    let { role } = adminField;
    let { city } = adminField;
    let { station } = adminField;
    let { stateList } = adminField;
    let { cluster } = adminField;
    console.log(role);

    let domain = email.slice(email.lastIndexOf("@") + 1);
    console.log("Email domain", domain);
    if (email === "") {
      this.props.showError("Email can not be blank!");
    }
    // else if(domain!= "affle.com" && domain!= "radiobigfm.com") {
    //   this.props.showError("Email must contain either affle.com or radiobigfm.com domain!");
    // }
    else if (domain !== "buyadsonbigfm.com" && domain !== "radiobigfm.com") {
      this.props.showError(
        "Email must contain either buyadsonbigfm.com or radiobigfm.com domain!"
      );
    } else {
      if (role && state && station && city) {
        if (
          role !== "" &&
          state !== "Select State" &&
          station !== "Select Station" &&
          city !== "Select City"
        ) {
          let data = {
            email,
            name,
            mobile,
            state,
            role,
            station,
            city,
            stateList,
            cluster,
          };
          this.props.updateAdmin(data);
        }
      } else if (role !== "") {
        this.props.showError("Select Role");
      } else if (state !== "" || state !== "Select State") {
        this.props.showError("Select State");
      } else if (city !== "" || city !== "Select City") {
        this.props.showError("Select City");
      } else if (stateList !== "" || stateList !== "Select stateList") {
        this.props.showError("Select stateList");
      } else if (station !== "" || station !== "Select Station") {
        this.props.showError("Select station");
      }
    }
  };

  render() {
    let { adminField } = this.state;
    let { adminDetail, hidePopup } = this.props;
    let { email } = adminDetail ? adminDetail : adminField;
    let { name } = adminDetail ? adminDetail : adminField;
    let { state } = adminDetail ? adminDetail : adminField;
    let { mobile } = adminDetail ? adminDetail : adminField;
    let { role } = adminDetail ? adminDetail : adminField;
    let { type } = adminDetail ? adminDetail : adminField;
    let { city } = adminDetail ? adminDetail : adminField;
    let { station } = adminDetail ? adminDetail : adminField;
    let { stateList } = adminDetail ? adminDetail : adminField;

    if (this.props.adminDetail && this.props.adminDetail.email) {
      this.state.adminField = this.props.adminDetail;
    }

    var valueLink = {
      value: this.props.adminDetail.email,
      requestChange: this.handleChange,
    };

    return (
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval updateSalesUserModal">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={hidePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="approval-content modal-body">
                <div className="popup-container reqst-rejection">
                  {this.props.adminDetail && this.props.adminDetail.email && (
                    <h2>Update admin details</h2>
                  )}
                  {!this.props.adminDetail && <h2>Add admin details</h2>}
                  <table className="tableView">
                    <tr>
                      <td>
                        <label htmlFor="email">Email</label>
                      </td>
                      <td>
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={email}
                          disabled
                          className="width200 inputBox"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        <label htmlFor="name">Name</label>{" "}
                      </td>
                      <td>
                        {" "}
                        <input
                          type="text"
                          name="name"
                          placeholder="name"
                          value={name}
                          disabled
                          onChange={this.handleChange}
                          className="width200 inputBox"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        <label htmlFor="mobile">Mobile</label>
                      </td>
                      <td>
                        {" "}
                        <input
                          type="text"
                          name="mobile"
                          placeholder="mobile"
                          value={mobile}
                          disabled
                          onChange={this.handleChange}
                          className="width200 inputBox"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        <placeholderText> Role </placeholderText>{" "}
                      </td>
                      <td>
                        <input
                          type="text"
                          name="name"
                          placeholder="name"
                          value={this.state.adminField.role}
                          disabled
                          className="width200 inputBox"
                        />
                      </td>
                      <td>
                        <select
                          className="typeDropdown drop-down-icon width200"
                          value={this.state.adminField.role}
                          onChange={(event) =>
                            this.handleRoleChange(event.target.value)
                          }
                        >
                          {this.state.roleList.map((role, index) => (
                            <option key={index} value={role.role}>
                              {role.name}
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        {" "}
                        <placeholderText> Cluster </placeholderText>{" "}
                      </td>
                      <td>
                        <input
                          type="text"
                          name="name"
                          placeholder="name"
                          value={this.state.adminField.cluster}
                          disabled
                          className="width200 inputBox"
                        />
                      </td>
                      <td>
                        <select
                          className="typeDropdown drop-down-icon width200"
                          value={this.state.adminField.cluster}
                          onChange={(event) =>
                            this.handleClusterChange(event.target.value)
                          }
                        >
                          {this.state.clusterList.map((cluster, index) => (
                            <option key={index} value={cluster.name}>
                              {cluster.name}
                            </option>
                          ))}
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        {" "}
                        <placeholderText> State </placeholderText>
                      </td>
                      <td>
                        <input
                          type="text"
                          name="name"
                          placeholder="name"
                          value={this.state.adminField.state}
                          disabled
                          className="width200 inputBox"
                        />
                      </td>
                      <td>
                        <select
                          className="typeDropdown drop-down-icon width200"
                          value={this.state.adminField.state}
                          onChange={(event) =>
                            this.handleStateChange(event.target.value)
                          }
                        >
                          {this.state.stateList.map((state, index) => (
                            <option key={index}>{state}</option>
                          ))}
                        </select>
                      </td>

                      {/* <td>    
                        <select className="typeDropdown drop-down-icon width200"  onChange= {event =>this.handleStateChange(event.target.value)} >
                            {this.state.stateList.map((state, index)=> (
                                <option key= {index}>{state}</option>
                            ))}
                        </select>
                      </td> */}
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        <placeholderText> City </placeholderText>
                      </td>
                      <td>
                        <input
                          type="text"
                          name="name"
                          placeholder="name"
                          value={this.state.adminField.city}
                          disabled
                          className="width200 inputBox"
                        />
                      </td>
                      <td>
                        <select
                          className="typeDropdown drop-down-icon width200"
                          value={this.state.adminField.city}
                          onChange={(event) =>
                            this.handleCityChange(event.target.value)
                          }
                        >
                          {this.state.cityList.map((city, index) => (
                            <option key={index}>{city.city}</option>
                          ))}
                        </select>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        {" "}
                        <placeholderText> Station </placeholderText>
                      </td>
                      <td>
                        <input
                          type="text"
                          name="name"
                          placeholder="name"
                          value={this.state.adminField.station}
                          disabled
                          className="width200 inputBox"
                        />
                      </td>
                      <td>
                        <select
                          className="typeDropdown drop-down-icon width200"
                          value={this.state.adminField.station}
                          onChange={(event) =>
                            this.handleStationChange(event.target.value)
                          }
                        >
                          {this.state.stationList.map((station, index) => (
                            <option key={index}>{station}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                  </table>
                  <div className="confirn-btn">
                    {this.props.adminDetail && this.props.adminDetail.email && (
                      <button
                        className="confirm-reqst"
                        onClick={this.updateAdmin}
                      >
                        {"Update"}
                      </button>
                    )}
                    {!this.props.adminDetail && (
                      <button className="confirm-reqst" onClick={this.addAdmin}>
                        {"ADD"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// const mapStateToProps = state => ({ stateList: state.user.get('stateList') })

const mapStateToProps = (state) => {
  console.log(state);
  return {
    stateList: state.sales.get("stateList"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    getStateList: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAdminUserComp);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/EditAdmin.jsx